import script from "./logo.vue?vue&type=script&setup=true&lang=js"
export * from "./logo.vue?vue&type=script&setup=true&lang=js"

import "./logo.vue?vue&type=style&index=0&id=3916f2ae&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3916f2ae"]])

export default __exports__